import React from 'react';
import { StyledLeafletPagenation } from '../styles';
import SwiperCore from 'swiper';
import { TLeafletItem } from 'src/types/types';

type TProps = {
  leafletData: TLeafletItem;
  contentSwiper?: SwiperCore;
  setGaEvent: (title: string) => void;
};

/**
 * @name 전단 페이지네이션
 */
function LeafletPagenation(props: TProps): React.ReactElement {
  // 현재 페이지
  const currentPage = props.contentSwiper?.realIndex
    ? props.contentSwiper.realIndex + 1
    : 1;

  // 버튼 클릭 시
  const handleChangeSlide = (type: string) => {
    if (!props.contentSwiper) return;
    if (type === 'next') {
      props.setGaEvent(`다음페이지(${props.contentSwiper.activeIndex + 1})`);
      props.contentSwiper.slideNext();
    }
    if (type === 'prev') {
      props.setGaEvent(`이전페이지(${props.contentSwiper.activeIndex - 1})`);
      props.contentSwiper.slidePrev();
    }
  };
  return (
    <StyledLeafletPagenation>
      <div className="paper-paging">
        <p>
          <strong>{currentPage}</strong> /{' '}
          {props.leafletData.leaflet_img_list.length}
        </p>
      </div>
      <button
        title="다음 페이지로"
        className="next_btn"
        onClick={() => handleChangeSlide('next')}
      ></button>
      <button
        title="이전 페이지로"
        className="pre_btn"
        onClick={() => handleChangeSlide('prev')}
      ></button>
    </StyledLeafletPagenation>
  );
}

export default LeafletPagenation;
